import type { InvivoLegacyNodeMaterialInputValue } from "../types/invivo_scene";

export function legacyVector2Input(value: unknown): InvivoLegacyNodeMaterialInputValue | undefined {
  if (Array.isArray(value) && value.length >= 2) {
    return typeof value[0] === "number" && typeof value[1] === "number"
      ? { x: value[0], y: value[1] }
      : undefined;
  }

  if (!value || typeof value !== "object") {
    return undefined;
  }

  const vector = value as { x?: unknown; y?: unknown };

  return typeof vector.x === "number" && typeof vector.y === "number"
    ? { x: vector.x, y: vector.y }
    : undefined;
}

export function legacyNumericInput(value: unknown): InvivoLegacyNodeMaterialInputValue | undefined {
  return typeof value === "number" ? value : undefined;
}

export function legacyHexColorInput(value: unknown): InvivoLegacyNodeMaterialInputValue | undefined {
  return typeof value === "string" && /^#[0-9a-f]{6}$/i.test(value) ? value : undefined;
}

export function supportedLegacyNodeMaterialInputs(values: Record<string, unknown>): Record<string, InvivoLegacyNodeMaterialInputValue> {
  const inputs: Record<string, InvivoLegacyNodeMaterialInputValue> = {};
  const baseColor = legacyHexColorInput(values.baseColor);
  const tilingDots = legacyVector2Input(values.tilingDots);
  const tilingCreases = legacyVector2Input(values.tilingCreases);
  const tilingCrumples = legacyVector2Input(values.tilingCrumples);
  const tilingMultiplier = legacyNumericInput(values.tilingMultiplier);

  if (baseColor !== undefined) inputs.baseColor = baseColor;
  if (tilingDots !== undefined) inputs.tilingDots = tilingDots;
  if (tilingCreases !== undefined) inputs.tilingCreases = tilingCreases;
  if (tilingCrumples !== undefined) inputs.tilingCrumples = tilingCrumples;
  if (tilingMultiplier !== undefined) inputs.tilingMultiplier = tilingMultiplier;

  return inputs;
}
